// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"e9885e87","681":"a3a02a3d","690":"9f6f3420","713":"a1c81e5e","810":"d8f9ac52","877":"162f2306"}[chunkId] + ".chunk.js";
};